import React from 'react';
import { Calendar } from 'lucide-react';
import { getMonthAbbr } from '../utils/dateUtils';

export default function BottomNav({ currentScreen, todayDay, todayMonth, goToToday, setCurrentScreen }) {
  return (
    <div className="shrink-0 bg-white border-t-2 border-gray-200">
      <div className="flex justify-center">
        <button
          onClick={() => {
            if (currentScreen === 'home') {
              goToToday();
            } else {
              setCurrentScreen('home');
            }
          }}
          className={`py-3 px-8 flex flex-col items-center gap-1 transition-colors ${currentScreen === 'home' ? 'text-blue-600' : 'text-gray-500'}`}
        >
          <div className="relative w-7 h-7 flex items-center justify-center">
            <Calendar size={28} className="absolute inset-0" strokeWidth={1.5} />
            <span className="absolute text-[9px] font-bold mt-2">
              {todayDay}
            </span>
          </div>
          <span className="text-xs font-medium">{getMonthAbbr(todayMonth)}</span>
        </button>
      </div>
    </div>
  );
}
